import React, { useEffect } from 'react';
import { Accordion } from '@gerdau/hefesto-mais-web';
import { HelpCenterAccordionItem } from '../HelpCenterAccordionItem';
import { HelpCenterAttachments } from '../HelpCenterAttachments';

import { QuestionContainer, QuestionTitle, AccordionContainer } from './styles';
import { useParams } from 'react-router-dom';
import { ApplicationState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { GetFlag } from '../../../utils/featureFlag';
import { loadHelpCenterTopics } from '../../../store/ducks/help-center/actions';
import { splitTopics } from '../helpCenterTopics';

const HelpCenterQuestionCommerce = ({ categoryId }: { categoryId: string }) => {
  const dispatch = useDispatch();

  const numericCategoryId = Number(categoryId);

  const topics = useSelector(
    (state: ApplicationState) =>
      state.helpCenter.commerce.topicsByCategory[numericCategoryId]
  );

  useEffect(() => {
    if (!Number.isNaN(numericCategoryId)) {
      dispatch(loadHelpCenterTopics(numericCategoryId));
    }
  }, [numericCategoryId]);

  if (!topics) {
    return null;
  }

  const { questions, manuals } = splitTopics(topics);

  return (
    <QuestionContainer>
      {questions.length > 0 && (
        <>
          <QuestionTitle>Perguntas</QuestionTitle>

          <AccordionContainer>
            {questions.map((item) => (
              <Accordion
                key={item.id}
                data={[
                  {
                    id: String(item.id),
                    title: item.title,
                    content: (
                      <HelpCenterAccordionItem
                        content={item.description}
                        isHtml
                      />
                    )
                  }
                ]}
              />
            ))}
          </AccordionContainer>
        </>
      )}

      {manuals && <HelpCenterAttachments manuals={manuals} />}
    </QuestionContainer>
  );
};

const HelpCenterQuestionLegacy = ({ categoryId }: { categoryId: string }) => {
  const FAQ = useSelector((state: ApplicationState) => state.helpCenter.faq);

  const category = FAQ.categories.find((item) => item.id === categoryId);

  const questions = FAQ.question.filter((item) =>
    item.categories.some((itm) => itm === categoryId)
  );

  if (!questions || !category) {
    return null;
  }

  return (
    <QuestionContainer>
      {questions && questions.length > 0 && (
        <>
          <QuestionTitle>Perguntas</QuestionTitle>

          <AccordionContainer>
            {questions?.map((item) => (
              <Accordion
                key={item.question}
                data={[
                  {
                    id: item.question,
                    title: item.question,
                    content: <HelpCenterAccordionItem content={item.answer} />
                  }
                ]}
              />
            ))}
          </AccordionContainer>
        </>
      )}

      <HelpCenterAttachments categories={[category.id]} />
    </QuestionContainer>
  );
};

export const HelpCenterQuestion = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const isNewApiEnabled = GetFlag('help_center_new_api');

  if (isNewApiEnabled) {
    return <HelpCenterQuestionCommerce categoryId={categoryId} />;
  }

  return <HelpCenterQuestionLegacy categoryId={categoryId} />;
};
